function Link( props: {link: string, children: string} ) {
    return (
        <a href={props.link}>{props.children}</a>
    )
}
export default Link;